import React from 'react';
import classnames from 'classnames';
import './Alert.less';

interface IButtonInfo {
    text: string;
    onClick?: () => void;
}

export type IActionInfo = IButtonInfo | string | JSX.Element;

export interface AlertPropInfo {
    text: any;
    msg?: string;
    id: any;
    actions?: IActionInfo[];
}

export interface AlertPropType {
    info: AlertPropInfo;
    prefixCls?: string;
    onClose: (id, type) => void;
}

class Alert extends React.Component<AlertPropType, any> {
    static defaultProps = {
        prefixCls: 'alert'
    };

    onClick(actionInfo) {
        const {onClose, info} = this.props;
        if (onClose) {
            onClose(info.id, 'alert');
            if (actionInfo['onClick']) {
                actionInfo['onClick']();
            }
        }
    }

    renderButton(actionInfo: IActionInfo, idx: number) {
        let el;
        let hasListen: boolean = false;
        if (typeof actionInfo == 'string') {
            el = actionInfo;
        } else if (typeof actionInfo == 'object' && actionInfo['text']) {
            el = actionInfo['text'];
            hasListen = !!actionInfo['onClick'];
        } else {
            el = actionInfo;
        }
        let {prefixCls} = this.props;
        let cls = classnames({
            [`${prefixCls}-wrapper-listen-btn`]: hasListen
        });
        return <div className={cls} key={idx} onClick={() => this.onClick(actionInfo)}>
            {el}
        </div>;
    }

    render() {
        const {prefixCls, info, /* onClose */} = this.props;
        let actions = info.actions || [];
        let cls = classnames({
            [`${prefixCls}-wrapper-buttonset`]: actions.length == 2,
            [`${prefixCls}-wrapper-buttons`]: actions.length != 2
        });
        /* onClick={(e)=>{ if(e.target["className"]==prefixCls) onClose(info.id, 'alert')}} */
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}-wrapper`}>
                    <div className={info.msg ? `${prefixCls}-wrapper-contentDif` : `${prefixCls}-wrapper-content`}>
                        <p>{info.text}</p>
                        {info.msg && <p>{info.msg}</p>}
                    </div>
                    <div className={cls}>
                        {actions.map((item, idx) => this.renderButton(item, idx))}
                    </div>
                </div>
            </div>
        );
    }
}

export default Alert;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/notice/Alert.tsx